import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'

const data = [
  {
    id: 1,
    image: IMG1,
    title: 'Insurance Management System',
    github:'https://github.com/Zishan23/Insurance-Management-Website',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  },
  {
    id: 2,
    image: IMG2,
    title: 'Volunteer Stories',
    github: 'https://github.com/Zishan23/Volunteer-Story',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  },
  {
    id: 3,
    image: IMG3,
    title: 'Mobile Fruit Recognition',
    github: 'https://github.com/Zishan23/Volunteer-Story',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  },

  {
    id: 4,
    image: IMG4,
    title: 'Copper 24',
    github: 'https://github.com/Zishan23/Volunteer-Story',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  },
  {
    id: 5,
    image: IMG5,
    title: 'Multimedia Image Retrival',
    github: 'https://github.com/Zishan23/Multimedia-Image-Retrieval',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  },
  {
    id: 6,
    image: IMG6,
    title: 'Social Media Management',
    github: 'https://github.com/Zishan23/AP-Assignment2',
    demo: 'https://github.com/Zishan23/Volunteer-Story'

  }
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>
      <p className='portfolio_intro'>
        Selected projects across full-stack product engineering, UI development, and applied machine learning.
      </p>

      <div className="container portfolio_container">

       {
        data.map(({id, image, title, github, demo}) => {
          return (
            <article key={id}className='portfolio_item'>
            <div className="portfolio_item-image">
             <img src={image} alt={title} />
            </div>
            <h3>{title}</h3>
            <div className="portfolio_item-cta">
            <a href={github} className='btn' target='_blank' rel='noreferrer'>Github</a>
            <a href={demo} className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
            </div>
           </article>
          )

        })
       }

       

      </div>
    </section>
  )
}

export default Portfolio